var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSheetMinimalProjectElement',{attrs:{"title":_vm.title,"text-alignment":_vm.textAlignment}})
}
var staticRenderFns = []

export { render, staticRenderFns }